// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import { faFacebook, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
// import the phone and email icons
import { faEnvelope, faPhone, faQuoteRight, faQuoteLeft, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faLightbulb } from '@fortawesome/free-regular-svg-icons';

// add the imported icons to the library
library.add(faFacebook, faTwitter, faInstagram, faEnvelope, faPhone, faLightbulb, faQuoteLeft, faQuoteRight, faMapMarkerAlt);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();



// WEBPACK FOOTER //
// ./scripts/main.js